import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-order-number-per-treatment-type-select',
    standalone: true,
    imports: [CommonModule, RadioButtonModule, FormsModule],
    templateUrl: './order-number-per-treatment-type-select.component.html',
    styleUrls: ['./order-number-per-treatment-type-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OrderNumberPerTreatmentTypeSelectComponent),
            multi: true,
        },
    ],
})
export class OrderNumberPerTreatmentTypeSelectComponent implements ControlValueAccessor {
    @Input() isDisabled = false;

    protected readonly uid = Math.random().toString(36).slice(2, 8);
    protected value: boolean | null = null;

    protected onChangeFn?: (value: boolean | null) => unknown;
    protected onTouchedFn?: () => unknown;

    protected onContainerClick(event: Event, value: boolean | null) {
        if (!event.defaultPrevented) {
            this.onCheck(value);
            this.onTouchedFn?.();
        }
    }

    protected onCheck(value: boolean | null) {
        this.value = value;
        this.onChangeFn?.(this.value);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'boolean') {
            this.value = obj;
        } else {
            this.value = null;
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
}
